export default "__VITE_PUBLIC_ASSET__4a7e07ca__"